import React, { Component } from "react";
import { IconButton, Button } from "@material-ui/core";
import Launch from "@material-ui/icons/Launch";
import ViewCarouselIcon from "@material-ui/icons/ViewCarousel";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import PaymentIcon from "@material-ui/icons/Payment";
import CancelIcon from "@material-ui/icons/Cancel";
import ReceiptIcon from "@material-ui/icons/Receipt";
import SearchIcon from "@material-ui/icons/Search";
import RefreshIcon from "@material-ui/icons/Refresh";
import GetAppIcon from "@material-ui/icons/GetApp";
import AssignmentIcon from "@material-ui/icons/Assignment";
import {
  Modal,
  Descriptions,
  Tag,
  message,
  Select,
  Alert,
  Table,
  Card,
  Space,
  Empty,
  Tooltip,
} from "antd";
import { Input } from "antd";
import { PostData } from "../../../api/service";
import CertificateEditModal from "./CertificateEditModal";
import {
  Applicant,
  ApprovalTag,
  AddressCell,
  DocumentsCell,
  PaymentCell,
  RequestStatusTag,
  avatarColor,
  approvalText,
  paymentText,
  statusText,
  downloadCsv,
  matchesSearch,
} from "../certificateTableUtils";
import "../Verification/certificate-verification.css";

const { TextArea } = Input;

export default class RequestTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      showModal: false,
      reason: "",
      showEditModal: false,
      viewModal: false,
      viewData: null,
      paymentModal: false,
      paymentData: null,
      ref_no: "",
      amount_paid: "",
      payment_mode: "OFFLINE",
      isPaymentSubmitting: false,
      search: "",
    };
  }

  typeFilters() {
    let seen = [];
    let table_data = Array.isArray(this.props.table_data)
      ? this.props.table_data
      : [];
    table_data.forEach((el) => {
      if (el.type_name && seen.indexOf(el.type_name) === -1) {
        seen.push(el.type_name);
      }
    });
    return seen.map((el) => ({ text: el, value: el }));
  }

  stageFilters() {
    let seen = [];
    let table_data = Array.isArray(this.props.table_data)
      ? this.props.table_data
      : [];
    table_data.forEach((el) => {
      if (el.now_at && seen.indexOf(el.now_at) === -1) {
        seen.push(el.now_at);
      }
    });
    return seen.map((el) => ({ text: el, value: el }));
  }

  onPaymentClick(el) {
    this.setState({
      paymentModal: true,
      paymentData: el,
      ref_no: "",
      amount_paid: el.registration_fee != null ? `${el.registration_fee}` : "",
      payment_mode: "OFFLINE",
    });
  }

  onPaymentCancel() {
    this.setState({
      paymentModal: false,
      paymentData: null,
      ref_no: "",
      amount_paid: "",
      payment_mode: "OFFLINE",
      isPaymentSubmitting: false,
    });
  }

  onPaymentSubmit() {
    let { paymentData, ref_no, amount_paid, payment_mode } = this.state;

    if (`${ref_no}`.trim() === "") {
      message.error("Please enter the payment reference number");
      return;
    }

    if (`${amount_paid}`.trim() === "" || isNaN(Number(amount_paid))) {
      message.error("Please enter a valid amount");
      return;
    }

    this.setState({ isPaymentSubmitting: true });

    PostData(`/${this.props.username}/update-certificate-payment-status`, {
      certificate_request_id: paymentData.id,
      ref_no: `${ref_no}`.trim(),
      amount_paid: `${amount_paid}`.trim(),
      payment_mode,
    })
      .then((resp) => {
        this.setState({ isPaymentSubmitting: false });

        if (resp && resp.status) {
          message.success(resp.status_text || "Payment status updated");
          this.onPaymentCancel();
          this.props.reloadAllData();
        } else {
          message.error(
            (resp && resp.status_text) || "Could not update the payment status"
          );
        }
      })
      .catch(() => {
        this.setState({ isPaymentSubmitting: false });
        message.error("Could not update the payment status. Please try again.");
      });
  }

  onActionClick(el) {
    this.props.actionClick(el);
  }

  onViewClick(el){
    this.setState({
      viewModal: true,
      viewData: el
    })
  }

  onViewCancel() {
    this.setState({
      viewModal: false,
      viewData: null
    })
  }

  onPrintClick(el) {
    this.props.printClick(el);
  }

  onButtonClick = (id) => {
    this.props.onButtonClick(id);
  };

  onGenerateClick(el) {
    this.setState({
      id: el.id,
      showEditModal: true,
    });
  }

  onEditSubmit() {
    // submit the data and generate the certificate with certificate_sl_no
  }

  onCancel(el) {
    this.setState({
      id: el.id,
      showModal: true,
    });
  }

  onCancelSubmit(data) {
    PostData(
      `/${this.props.apikey}/${this.props.username}/cancelcertificaterequest`,
      data
    ).then((resp) => {
      Modal.info({
        title: "Message",
        content: resp,
        showIcon: true,
        onOk: () => {
          this.props.__getRequests();
        },
      });
      this.setState({
        id: "",
        showModal: false,
        reason: "",
      });
    });
  }

  buildRows() {
    let table_data = Array.isArray(this.props.table_data)
      ? this.props.table_data
      : [];

    return table_data.filter((el) => matchesSearch(el, this.state.search));
  }

  exportCsv() {
    let headers = [
      "#",
      "Certificate Type",
      "Student Name",
      "Father's Name",
      "Mother's Name",
      "Gender",
      "Address",
      "Course",
      "Semester",
      "Roll No",
      "Email",
      "Phone",
      "Currently At",
      "Payment",
      "Verification Status",
      "Library Status",
      "Status",
      "Timestamp",
    ];

    let rows = this.buildRows().map((el, index) => [
      index + 1,
      el.type_name,
      el.name,
      el.father_name,
      el.mother_name,
      el.gender,
      el.address,
      el.course,
      el.semester,
      el.roll_no,
      el.email,
      el.phone,
      el.now_at,
      paymentText(el),
      approvalText(el.verification_status, el.verification_status_on),
      approvalText(el.library_status, el.library_verification_on),
      statusText(el),
      el.time_stamp,
    ]);

    downloadCsv("certificate-requests.csv", headers, rows);
  }

  render() {
    let rows = this.buildRows();
    let total = Array.isArray(this.props.table_data)
      ? this.props.table_data.length
      : 0;

    const columns = [
      {
        title: "#",
        key: "index",
        width: 56,
        fixed: "left",
        render: (text, record, index) => (
          <span className="cert-muted">{index + 1}</span>
        ),
      },
      {
        title: "Applicant",
        key: "applicant",
        width: 220,
        fixed: "left",
        sorter: (a, b) => `${a.name}`.localeCompare(`${b.name}`),
        render: (text, el) => <Applicant el={el} />,
      },
      {
        title: "Certificate Type",
        key: "type",
        width: 170,
        filters: this.typeFilters(),
        onFilter: (value, el) => el.type_name === value,
        render: (text, el) => (
          <Tag
            color={avatarColor(el.type_name)}
            style={{ marginInlineEnd: 0, fontWeight: 600 }}
          >
            {el.type_name}
          </Tag>
        ),
      },
      {
        title: "Parents",
        key: "parents",
        width: 190,
        render: (text, el) => (
          <div>
            <div className="cert-muted">
              <b style={{ color: "#33415c" }}>F:</b> {el.father_name || "—"}
            </div>
            <div className="cert-muted">
              <b style={{ color: "#33415c" }}>M:</b> {el.mother_name || "—"}
            </div>
          </div>
        ),
      },
      {
        title: "Contact",
        key: "contact",
        width: 200,
        render: (text, el) => (
          <div>
            <div className="cert-muted">{el.email || "—"}</div>
            <div className="cert-muted">{el.phone || "—"}</div>
          </div>
        ),
      },
      {
        title: "Address",
        key: "address",
        width: 220,
        render: (text, el) => <AddressCell address={el.address} />,
      },
      {
        title: "Course & Semester",
        key: "course",
        width: 170,
        render: (text, el) => (
          <div>
            <div className="cert-name">{el.course || "—"}</div>
            <div className="cert-muted">Semester / Year: {el.semester || "—"}</div>
          </div>
        ),
      },
      {
        title: "Documents",
        key: "documents",
        width: 150,
        render: (text, el) => <DocumentsCell el={el} />,
      },
      {
        title: "Currently At",
        dataIndex: "now_at",
        key: "now_at",
        width: 130,
        filters: this.stageFilters(),
        onFilter: (value, el) => el.now_at === value,
        render: (text) => (
          <Tag color={text === "ADMIN" ? "green" : "blue"} style={{ marginInlineEnd: 0 }}>
            {text || "—"}
          </Tag>
        ),
      },
      {
        title: "Payment",
        key: "payment",
        width: 150,
        filters: [
          { text: "Paid", value: 1 },
          { text: "Not Paid", value: 0 },
        ],
        onFilter: (value, el) => (el.payment_status == 1 ? 1 : 0) === value,
        render: (text, el) => <PaymentCell el={el} />,
      },
      {
        title: "Verification",
        key: "verification",
        width: 150,
        render: (text, el) => (
          <ApprovalTag
            status={el.verification_status}
            on={el.verification_status_on}
            by={el.verification_status_by}
          />
        ),
      },
      {
        title: "Library",
        key: "library",
        width: 150,
        render: (text, el) => (
          <ApprovalTag
            status={el.library_status}
            on={el.library_verification_on}
            by={el.library_verification_by}
          />
        ),
      },
      {
        title: "Status",
        key: "status",
        width: 150,
        filters: [
          { text: "Pending", value: 0 },
          { text: "Generated", value: 1 },
          { text: "Cancelled", value: 2 },
        ],
        onFilter: (value, el) =>
          value === 2 ? el.status != 0 && el.status != 1 : el.status == value,
        render: (text, el) => <RequestStatusTag el={el} />,
      },
      {
        title: "Submitted On",
        dataIndex: "time_stamp",
        key: "time_stamp",
        width: 150,
        sorter: (a, b) => `${a.time_stamp}`.localeCompare(`${b.time_stamp}`),
        render: (text) => <span className="cert-muted">{text}</span>,
      },
      {
        title: "Action",
        key: "action",
        width: 190,
        fixed: "right",
        render: (text, el) =>
          el.status == 0 ? (
            <Space direction="vertical" size={6}>
              <Button
                size="small"
                variant="contained"
                disableElevation
                className="cert-action-btn"
                startIcon={<Launch style={{ fontSize: 16 }} />}
                onClick={this.onGenerateClick.bind(this, el)}
                style={{
                  background: "linear-gradient(120deg, #1c4fd6, #3fb0f7)",
                  color: "#fff",
                }}
              >
                Generate
              </Button>

              <Space size={4} wrap>
                <Tooltip title="View full request">
                  <IconButton size="small" onClick={() => this.onViewClick(el)}>
                    <ViewCarouselIcon style={{ fontSize: 18, color: "#2f7bf5" }} />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Payment receipt">
                  <IconButton
                    size="small"
                    target="_blank"
                    href={`/certificate/receipt-print?certificate_request_id=${el.id}`}
                  >
                    <ReceiptIcon style={{ fontSize: 18, color: "#0ea5a4" }} />
                  </IconButton>
                </Tooltip>

                {el.payment_status != 1 && (
                  <Tooltip title="Update payment status">
                    <IconButton
                      size="small"
                      onClick={() => this.onPaymentClick(el)}
                    >
                      <PaymentIcon style={{ fontSize: 18, color: "#f59e0b" }} />
                    </IconButton>
                  </Tooltip>
                )}

                <Tooltip title="Cancel request">
                  <IconButton
                    size="small"
                    onClick={this.onCancel.bind(this, el)}
                  >
                    <CancelIcon style={{ fontSize: 18, color: "#dc2626" }} />
                  </IconButton>
                </Tooltip>
              </Space>
            </Space>
          ) : null,
      },
    ];

    return (
      <div>
        <Card
          className="cert-card"
          styles={{ body: { padding: 16 } }}
          title={
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: 10,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#fff5e0",
                  color: "#f59e0b",
                }}
              >
                <AssignmentIcon style={{ fontSize: 20 }} />
              </div>
              <div>
                <div className="cert-card-title">Certificate Requests</div>
                <div className="cert-card-sub">
                  Pending and cancelled requests. Generate a certificate once
                  verification and library clearance are done.
                </div>
              </div>
            </div>
          }
          extra={
            <Space>
              <span className="cert-search">
                <Input
                  allowClear
                  value={this.state.search}
                  onChange={(e) => this.setState({ search: e.target.value })}
                  placeholder="Search name, roll no, type, address"
                  prefix={<SearchIcon style={{ fontSize: 16, color: "#94a3b8" }} />}
                  style={{ width: 280 }}
                />
              </span>
              <Tooltip title="Download as CSV">
                <Button
                  size="small"
                  onClick={() => this.exportCsv()}
                  style={{
                    minWidth: 36,
                    borderRadius: 8,
                    background: "#eaf2ff",
                    color: "#2f7bf5",
                  }}
                >
                  <GetAppIcon style={{ fontSize: 18 }} />
                </Button>
              </Tooltip>
              <Tooltip title="Reload">
                <Button
                  size="small"
                  onClick={() => this.props.reloadAllData()}
                  style={{
                    minWidth: 36,
                    borderRadius: 8,
                    background: "#eaf2ff",
                    color: "#2f7bf5",
                  }}
                >
                  <RefreshIcon style={{ fontSize: 18 }} />
                </Button>
              </Tooltip>
            </Space>
          }
        >
          <Space size={8} style={{ marginBottom: 12 }}>
            <Tag color="blue" style={{ fontWeight: 600 }}>
              Total: {total}
            </Tag>
            {`${this.state.search}`.trim() !== "" && (
              <Tag color="purple" style={{ fontWeight: 600 }}>
                Showing: {rows.length}
              </Tag>
            )}
          </Space>

          <Table
            className="cert-table"
            size="small"
            rowKey={(el) => el.id}
            columns={columns}
            dataSource={rows}
            rowClassName={(el, index) =>
              el.now_at === "ADMIN"
                ? "cert-row-admin"
                : index % 2 === 1
                ? "cert-row-alt"
                : ""
            }
            scroll={{ x: "max-content" }}
            pagination={{
              pageSize: 25,
              showSizeChanger: true,
              pageSizeOptions: ["10", "25", "50", "100"],
              showTotal: (t, range) => `${range[0]}-${range[1]} of ${t} requests`,
            }}
            locale={{
              emptyText: <Empty description="No certificate requests found." />,
            }}
          />
        </Card>

        {this.state.showModal ? (
          <Modal
            open={this.state.showModal}
            onOk={() =>
              this.onCancelSubmit({
                id: this.state.id,
                reason: this.state.reason,
              })
            }
            onCancel={() =>
              this.setState({
                id: "",
                showModal: false,
                reason: "",
              })
            }
            okText={`SUBMIT`}
            cancelText={`CANCEL`}
            title={`Cancel Request`}
          >
            <TextArea
              rows={4}
              placeholder="Reason for cancellation"
              onChange={(e) =>
                this.setState({
                  reason: e.target.value,
                })
              }
              required
            />
          </Modal>
        ) : null}

        {this.state.paymentModal && this.state.paymentData && (
          <Modal
            open={this.state.paymentModal}
            title={`Update Payment Status`}
            okText={`UPDATE PAYMENT`}
            cancelText={`CANCEL`}
            confirmLoading={this.state.isPaymentSubmitting}
            onOk={() => this.onPaymentSubmit()}
            onCancel={() => this.onPaymentCancel()}
          >
            <Alert
              type="warning"
              showIcon
              message="Use this only when the online payment has failed but the fee is actually received."
              description="The request will be marked as paid and forwarded for verification. This cannot be undone from here."
              style={{ marginBottom: 16 }}
            />

            <Descriptions column={1} bordered size="small">
              <Descriptions.Item label="Student">
                {this.state.paymentData.name}
              </Descriptions.Item>
              <Descriptions.Item label="Certificate Type">
                {this.state.paymentData.type_name}
              </Descriptions.Item>
              <Descriptions.Item label="Roll No">
                {this.state.paymentData.roll_no}
              </Descriptions.Item>
              <Descriptions.Item label="Current Payment Status">
                <Tag color="red">Not Paid</Tag>
              </Descriptions.Item>
            </Descriptions>

            <div style={{ marginTop: 16 }}>
              <div style={{ fontWeight: 600, marginBottom: 4 }}>
                Payment Reference No / Transaction Id
              </div>
              <Input
                placeholder="e.g. bank reference, UPI transaction id, receipt no"
                value={this.state.ref_no}
                onChange={(e) => this.setState({ ref_no: e.target.value })}
              />
            </div>

            <div style={{ marginTop: 12 }}>
              <div style={{ fontWeight: 600, marginBottom: 4 }}>
                Amount Received (Rs.)
              </div>
              <Input
                type="number"
                placeholder="Amount paid by the student"
                value={this.state.amount_paid}
                onChange={(e) => this.setState({ amount_paid: e.target.value })}
              />
            </div>

            <div style={{ marginTop: 12 }}>
              <div style={{ fontWeight: 600, marginBottom: 4 }}>
                Payment Mode
              </div>
              <Select
                style={{ width: "100%" }}
                value={this.state.payment_mode}
                onChange={(value) => this.setState({ payment_mode: value })}
                options={[
                  { value: "OFFLINE", label: "Offline / Counter" },
                  { value: "CASH", label: "Cash" },
                  { value: "UPI", label: "UPI" },
                  { value: "NEFT", label: "NEFT / Bank Transfer" },
                  { value: "CHEQUE", label: "Cheque / DD" },
                  { value: "OTHERS", label: "Others" },
                ]}
              />
            </div>
          </Modal>
        )}

        {this.state.showEditModal && (
          <CertificateEditModal
            certificate_request_id={this.state.id}
            reload={() => {
              this.props.reloadAllData();
            }}
            onCancel={() => {
              this.setState({
                id: "",
                showEditModal: false,
              });
            }}
          />
        )}


        {this.state.viewModal && this.state.viewData && (
        <Dialog
          open={this.state.viewModal}
          maxWidth={`lg`}
          onClose={() => this.onViewCancel()}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Certificate Request"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Here are the details submitted by the student for certificate.
            </DialogContentText>

            <Descriptions column={2} bordered={true} size="small">
              <Descriptions.Item label="Certificate Type">
                {this.state.viewData.type_name}
              </Descriptions.Item>
              <Descriptions.Item label="Applied By">
                {this.state.viewData.name}
              </Descriptions.Item>
              <Descriptions.Item label="Course">
                {this.state.viewData.course}
              </Descriptions.Item>
              <Descriptions.Item label="Semester/Year">
                {this.state.viewData.semester}
              </Descriptions.Item>
              <Descriptions.Item label="Father's Name">
                {this.state.viewData.father_name}
              </Descriptions.Item>
              <Descriptions.Item label="Mother's Name">
                {this.state.viewData.mother_name}
              </Descriptions.Item>
              <Descriptions.Item label="Gender">
                {this.state.viewData.gender}
              </Descriptions.Item>
              <Descriptions.Item label="Address">
                {this.state.viewData.address}
              </Descriptions.Item>
              <Descriptions.Item label="Roll No">
                {this.state.viewData.roll_no}
              </Descriptions.Item>
              <Descriptions.Item label="Email">
                {this.state.viewData.email}
              </Descriptions.Item>
              <Descriptions.Item label="Phone">
                {this.state.viewData.phone}
              </Descriptions.Item>

              <Descriptions.Item label="Do you have Library Card ?">
                {this.state.viewData.has_library_card}
              </Descriptions.Item>

              {this.state.viewData.has_library_card == "YES" && <Descriptions.Item label="Library Card ID/ User Id">
                {this.state.viewData.library_card_no}
              </Descriptions.Item>}

              {this.state.viewData.type_code == "BC" && (
                <>
                  <Descriptions.Item label="Session">
                    {this.state.viewData.session}
                  </Descriptions.Item>
                </>
              )}

              {this.state.viewData.type_code == "CC" && (
                <>
                  <Descriptions.Item label="Year">
                    {this.state.viewData.year}
                  </Descriptions.Item>
                  <Descriptions.Item label="Are you still studying ?">
                    {this.state.viewData.is_studying}
                  </Descriptions.Item>
                </>
              )}

              {this.state.viewData.type_code == "MPC" && (
                <>
                  <Descriptions.Item label="University Roll No">
                    {this.state.viewData.university_roll_no}
                  </Descriptions.Item>
                  <Descriptions.Item label="University Registration No">
                    {this.state.viewData.registration_no}
                  </Descriptions.Item>
                  <Descriptions.Item label="University Registration Year">
                    {this.state.viewData.registration_year}
                  </Descriptions.Item>

                  <Descriptions.Item label="Session">
                    {this.state.viewData.session}
                  </Descriptions.Item>

                  <Descriptions.Item label="Subject">
                    {this.state.viewData.subject}
                  </Descriptions.Item>

                  <Descriptions.Item label="Passing Year">
                    {this.state.viewData.year}
                  </Descriptions.Item>

                  <Descriptions.Item label="Passing Month">
                    {this.state.viewData.passing_month}
                  </Descriptions.Item>

                  <Descriptions.Item label="CGPA">
                    {this.state.viewData.cgpa}
                  </Descriptions.Item>
                </>
              )}

              {this.state.viewData.type_code == "TC" && (
                <>
                  <Descriptions.Item label="Are you still studying ?">
                    {this.state.viewData.is_studying}
                  </Descriptions.Item>
                  <Descriptions.Item label="Subject">
                    {this.state.viewData.subject}
                  </Descriptions.Item>

                  <Descriptions.Item label="CPGA">
                    {this.state.viewData.cgpa}
                  </Descriptions.Item>

                  <Descriptions.Item label="Year">
                    {this.state.viewData.year}
                  </Descriptions.Item>
                </>
              )}

              {this.state.viewData.type_code == "PPC" && (
                <>
                <Descriptions.Item label="University Roll No">
                    {this.state.viewData.university_roll_no}
                  </Descriptions.Item>
                  <Descriptions.Item label="Subject">
                    {this.state.viewData.subject}
                  </Descriptions.Item>
                  <Descriptions.Item label="CPGA">
                    {this.state.viewData.cgpa}
                  </Descriptions.Item>

                  <Descriptions.Item label="Year">
                    {this.state.viewData.year}
                  </Descriptions.Item>
                </>
              )}

              <Descriptions.Item label="Marksheet">
                {Array.isArray(this.state.viewData.marksheet_file_url) &&
                this.state.viewData.marksheet_file_url.length > 0 ? (
                  <a
                    target="_blank"
                    href={this.state.viewData.marksheet_file_url[0]}
                  >
                    View File
                  </a>
                ) : (
                  <span className="cert-muted">Not uploaded</span>
                )}
              </Descriptions.Item>

              <Descriptions.Item label="Registration">
                {Array.isArray(this.state.viewData.registration_file_url) &&
                this.state.viewData.registration_file_url.length > 0 ? (
                  <a
                    target="_blank"
                    href={this.state.viewData.registration_file_url[0]}
                  >
                    View File
                  </a>
                ) : (
                  <span className="cert-muted">Not uploaded</span>
                )}
              </Descriptions.Item>

              <Descriptions.Item label="Applied on">
                {this.state.viewData.date_of_application}
              </Descriptions.Item>
              <Descriptions.Item label="Submitted On">
                {this.state.viewData.time_stamp}
              </Descriptions.Item>
              <Descriptions.Item label="Currently at">
                <strong>{this.state.viewData.now_at}</strong>
              </Descriptions.Item>

              <Descriptions.Item label="Verification Status">
              {this.state.viewData.verification_status == 1 && (
                  <Tag color="#2ECC71">Verified</Tag>
                )}
                {this.state.viewData.verification_status == 0 && (
                  <Tag color="#A569BD">Not Verified</Tag>
                )}
                {this.state.viewData.verification_status == 2 && (
                  <Tag color="#C0392B">Rejected</Tag>
                )}
                &nbsp;
                <i>{this.state.viewData.verification_remarks}</i>
              </Descriptions.Item>
              {this.state.viewData.verification_status == 1 && (
                <Descriptions.Item label="Verified On">
                  {this.state.viewData.verification_status_on} by{" "}
                  <strong>{this.state.viewData.verification_status_by}</strong>
                </Descriptions.Item>
              )}
              <Descriptions.Item label="Library Status">
              {this.state.viewData.library_status == 1 && (
                  <Tag color="#2ECC71">Verified</Tag>
                )}
                {this.state.viewData.library_status == 0 && (
                  <Tag color="#A569BD">Not Verified</Tag>
                )}
                {this.state.viewData.library_status == 2 && (
                  <Tag color="#C0392B">Rejected</Tag>
                )}
                &nbsp;
                <i>{this.state.viewData.library_remarks}</i>
              </Descriptions.Item>
              {this.state.viewData.library_status == 1 && (
                <Descriptions.Item label="Library Verified On">
                  {this.state.viewData.library_verification_on} by{" "}
                  <strong>{this.state.viewData.library_verification_by}</strong>
                </Descriptions.Item>
              )}


              
            </Descriptions>
            
             
            
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.onViewCancel()} color="primary">
              Close
            </Button>
         
          </DialogActions>
        </Dialog>
      )}
      </div>
    );
  }
}
